import React from 'react';

const pageInfo = {
  'reconciliation': { icon: '⚖️', desc: 'Bank reconciliation between system balance and actual bank statement' },
  'receipt-payment-consolidated': { icon: '📊', desc: 'Consolidated view of all receipts and payments across banks and cash' },
  'bank-slip': { icon: '🧾', desc: 'View and print bank deposit slips' },
  'bounce-report': { icon: '⚠️', desc: 'Report of bounced cheques and payment failures' },
  'general-ledger': { icon: '📒', desc: 'General ledger with all expense and income accounts' },
  'taxes-report': { icon: '🏛️', desc: 'TDS payable and other tax ledger accounts' },
  'journal-vouchers': { icon: '📝', desc: 'Journal voucher report for accounting entries' },
  'expense-report': { icon: '💸', desc: 'Detailed expense report by category and date' },
  'income-report': { icon: '💰', desc: 'Income report from all sources' },
  'vendor-report': { icon: '🏭', desc: 'Vendor ledger with purchase history and outstanding' },
  'regular-opening': { icon: '📋', desc: 'Regular opening balance for all members' },
  'supplementary-opening': { icon: '📋', desc: 'Supplementary opening balance for special charges' },
  'member-ledger-a': { icon: '👤', desc: 'Member ledger statement in Format A - Date wise view' },
  'member-ledger-b': { icon: '👤', desc: 'Detailed member ledger statement in Format B' },
  'bill-dashboard': { icon: '📊', desc: 'Bill generation and tracking dashboard' },
  'member-accounts': { icon: '🗂️', desc: 'Monthly account register for each member' },
  'receipts-collections': { icon: '📥', desc: 'Member receipts and collection register' },
  'interest-report': { icon: '📈', desc: 'Interest calculation report for overdue amounts' },
  'dues-advances': { icon: '⚠️', desc: 'Member outstanding dues and advances report' },
  'set-index': { icon: '⚙️', desc: 'Configure balance sheet index mapping for accounts' },
  'trial-balance': { icon: '⚖️', desc: 'Trial balance with opening, transactions and closing balances' },
  'format-a-dynamic': { icon: '📑', desc: 'Format A dynamic positions balance sheet' },
  'format-b-fixed': { icon: '📑', desc: 'Format B fixed positions balance sheet' },
  'balancesheet': { icon: '📊', desc: 'Detailed balance sheet of the society' },
  'fund-flow': { icon: '💹', desc: 'Month-wise fund flow statement' },
  'sms-report': { icon: '📱', desc: 'SMS log report sent to members' },
  'email-log': { icon: '📧', desc: 'Email log report with all outgoing emails' },
  'form-i': { icon: '📄', desc: 'Form I - Register of Members as per MCS Act' },
  'form-j': { icon: '📄', desc: 'Form J - Joint member list' },
};

const GenericPage = ({ pageId, pageLabel }) => {
  const info = pageInfo[pageId] || { icon: '📋', desc: 'This report will display relevant society data.' };

  return (
    <div className="fade-in">
      <div className="page-header">
        <h2>{pageLabel}</h2>
        <p>{info.desc}</p>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>From Date</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group">
          <label>To Date</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-primary">🔍 Search</button>
            <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023</p>
          <p>dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>{pageLabel} — Financial Year 2025-2026</p>
        </div>

        <div className="empty-state">
          <div style={{ fontSize: '64px', marginBottom: '12px' }}>{info.icon}</div>
          <h3 style={{ marginBottom: '8px', color: 'var(--text-primary)' }}>{pageLabel}</h3>
          <p style={{ marginBottom: '20px' }}>{info.desc}</p>
          <button className="btn btn-primary">🔍 Load Report</button>
        </div>
      </div>
    </div>
  );
};

export default GenericPage;
